export default "__VITE_ASSET__Dbr0Z68S__"